module.exports = __webpack_public_path__ + "img/f_03.0681b40.png";